import { Component, HostBinding, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig } from "../../field.interface";
@Component({
  selector: "app-date",
  template: `
      <div class="row" [hidden]="hidden()" >
        <mat-form-field class="col-12 demo-full-width margin-top" [formGroup]="group">
            <input matInput [matDatepicker]="picker" [formControlName]="field.name" [placeholder]="field.label" [readonly]="field.disabled">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-hint></mat-hint>
            <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
                <mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
            </ng-container>
        </mat-form-field>
    </div>

`,
  styles: []
})
export class DateComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  @HostBinding('class') class = '';
  constructor() {
  }
  ngOnInit() {
    this.class = this.field.claseGrillaBootstrap;
  }
  hidden() {
    return this.field.visible === false;
  }
}
